module.exports = function getResource(label, vars = []) {
    const resources = {
        selectUpToSamples: `Select up to ${vars[0]} sample(s)`,
        done: 'Done'
    };

    return resources[label];
};
